<script>
    import {onDestroy, onMount, tick} from "svelte";

    import HomeOurcafe from "../blocks/HomeOurcafe.svelte";

    let ourcafeImages = [
        { 'src': '/images/our_cafe_01.jpeg', 'alt': '' },
        { 'src': '/images/our_cafe_02.jpeg', 'alt': '' },
        { 'src': '/images/our_cafe_03.jpeg', 'alt': '' },
        { 'src': '/images/our_cafe_04.jpeg', 'alt': '' },
        { 'src': '/images/our_cafe_05.jpeg', 'alt': '' },
    ];

    import HomeMenu from "../blocks/HomeMenu.svelte";

    import { Server } from "../stores.js";
    import { Slider } from "../slider.js";

    let news = [];
    const getNews = async page => {
        let option = {
            headers: {'Content-type': 'application/json; charset=UTF-8'},
            method: 'GET',
        }
        return await fetch($Server + '/news' + (page ? '/' + page : ''), option)
            .then(async res => await res.json())
            .then(response => {
                // console.log(response);
                if (response.result === 'success') { // success
                    news = response.list;
                } else { // failed
                    console.log('오류가 발생하였습니다.')
                }
            }).catch(error => {
                console.log('오류가 발생하였습니다.')
                console.warn(error);
                return false;
            });
    }

    let timeout;
    let slider = {};
    onMount(async () => {
      clearTimeout(timeout);
      timeout = setTimeout(async () => {
          await getNews();
      }, 100);

      try {
        slider = new Slider({
          'slider'       : document.getElementById('js-intro-banners'),
          'slider_anchor': 'home-intro__anchor',
          'slider_active': 'home-intro__banner_active',
          'page'         : document.getElementById('js-intro-banner-pages'),
          'page_anchor'  : 'home-intro__page-anchor',
          'page_active'  : 'home-intro__page_active',
          'delay'        : 3000,
          'duration'     : 400,
        });
      } catch (e) {
        // console.warn(e);
      }
    });

    onDestroy(async () => {
      try {
        clearTimeout(timeout);
        await slider.destroy();
        await tick();
        slider = {};
      } catch (e) {
        // console.warn(e);
      }
    });

    import "../styles/home.css";

</script>

<section id="/home" class="home">
    <div class="home__intro home-intro">
        <ul id="js-intro-banners" class="home-intro__banners" data-move="N">
            <li class="home-intro__banner"><a class="home-intro__anchor" href="/#/coffee"><img class="home-intro__img" src="/images/banner1.png" alt="" /></a></li>
            <li class="home-intro__banner"><a class="home-intro__anchor" href="/#/coffee"><img class="home-intro__img" src="/images/banner2.png" alt="" /></a></li>
            <li class="home-intro__banner"><a class="home-intro__anchor" href="/#/coffee"><img class="home-intro__img" src="/images/banner3.png" alt="" /></a></li>
            <li class="home-intro__banner"><a class="home-intro__anchor" href="/#/coffee"><img class="home-intro__img" src="/images/banner4.png" alt="" /></a></li>
        </ul>
        <ul id="js-intro-banner-pages" class="home-intro__pages">
          <li class="home-intro__page home-intro__page_active"><a class="home-intro__page-anchor" >1</a></li>
          <li class="home-intro__page"><a class="home-intro__page-anchor" >2</a></li>
          <li class="home-intro__page"><a class="home-intro__page-anchor" >3</a></li>
          <li class="home-intro__page"><a class="home-intro__page-anchor" >4</a></li>
        </ul>
    </div>
    <div class="home__feature home-feature">
        <div class="header">
            <h1 class="header__heading heading heading_level_1">Coffee Mentor</h1>
            <span class="header__text text text_large">
              커피 멘토는 상권분석을 통한 매장 선정에서부터<span class="_newline" />
              인테리어, 매장 운영 지원까지<br />
              One-Stop Full-Service를 제공합니다.
            </span>
        </div>
        <ul class="home-feature__list">
            <li class="home-feature__item">
                <i class="home-feature__icon" data="01">상권분석</i>
                <span class="home-feature__text text text_large">상권분석</span>
            </li>
            <li class="home-feature__item">
                <i class="home-feature__icon" data="02">최고급 /></i>
                <span class="home-feature__text text text_large">최고급 원두</span>
            </li>
            <li class="home-feature__item">
                <i class="home-feature__icon" data="03">인테리어</i>
                <span class="home-feature__text text text_large">인테리어</span>
            </li>
            <li class="home-feature__item">
                <i class="home-feature__icon" data="04">무인운영</i>
                <span class="home-feature__text text text_large">무인운영</span>
            </li>
        </ul>
    </div>
    <div class="home__find home-find">
      <div class="home-find__header header">
          <h1 class="header__heading heading heading_level_1">매장찾기</h1>
          <span class="header__text text text_large">원하시는 지역의 매장을 자유롭게 검색해보세요.</span>
      </div>
      <form name="" class="home-find__form" on:submit|preventDefault="{() => location.href='#/find'}">
          <input type="text" name="" class="home-find__input" on:click|preventDefault="{() => location.href='#/find'}" />
          <input type="submit" value="" class="home-find__submit" on:click|preventDefault="{() => location.href='#/find'}" />
      </form>
    </div>

    <!-- HomeOurcafe -->
    <HomeOurcafe {ourcafeImages} />

    <!-- HomeMenu -->
    <HomeMenu />

    <div class="home__news home-news">
        <div class="header">
            <h1 class="header__heading heading heading_level_1">NEWS</h1>
            <!--<span class="header__text text">뉴스 관련 문구 추가</span>-->
        </div>

        <div class="home-news__more-outer">
            <a href="#/news" class="home-news__more" >More +</a>
        </div>
        <ul class="home-news__list">
            {#each news as item}
            <li class="home-news__item">
                <a href="{item.link}" target="_blank" class="home-news__anchor">
                    <h4 class="home-news__subject heading heading_level_4">{item.title}</h4>
                    <span class="home-news__date text">{item.shown_at_from.slice(0, 10)}</span>
                    <span class="home-news__content text">{item.content}</span>
                </a>
            </li>
            {/each}
        </ul>
    </div>
</section>

